// Форматування грошей. Єдина точка для валюти застосунку.
// Зараз дефолт — злотий (PLN). У майбутньому валюту можна брати не з константи,
// а, напр., з профілю майстра/послуги — тоді достатньо передати currency у formatMoney.

export const DEFAULT_CURRENCY = process.env.REACT_APP_CURRENCY || 'PLN';

// Реєстр валют: додати нову — додати запис (locale впливає на роздільники/позицію символу).
export const CURRENCIES = {
  PLN: { locale: 'pl-PL' },
  UAH: { locale: 'uk-UA' },
  EUR: { locale: 'de-DE' },
  USD: { locale: 'en-US' },
  GBP: { locale: 'en-GB' },
};

// formatMoney(115) -> "115 zł"; formatMoney(99.5, { currency: 'EUR' }) -> "99,50 €"
export const formatMoney = (amount, { currency = DEFAULT_CURRENCY } = {}) => {
  const n = Number(amount);
  const value = Number.isFinite(n) ? n : 0;
  const locale = CURRENCIES[currency]?.locale || 'pl-PL';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value} ${currency}`;
  }
};
